import { OAuthModuleConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';


export const authModuleConfig: OAuthModuleConfig = {
    resourceServer: {
        allowedUrls: ['${window.location.origin}', environment.data_url],
        sendAccessToken: true,
    }
};